import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CatalogueService } from '@catalogue';

export const HasSelectedApplianceGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const catalogueService = inject(CatalogueService);

  const hasAppliance = !!catalogueService.steppedFormAppliance();

  if (hasAppliance) {
    return true;
  }

  router.navigateByUrl('appliance-details');
  return false;
};
